import { weeeFeedbackInitialState } from '~shared/modules/weee-landing-page/store/weee-feedback/weee-feedaback.state';
import {
  WeeeFeedabackActionTypes,
  WeeeFeedabackActionUnion
} from '~shared/modules/weee-landing-page/store/weee-feedback/weee-feedaback.actions';

export function weeeFeedbackReducer(state = weeeFeedbackInitialState, action: WeeeFeedabackActionUnion) {

  switch (action.type) {
    case WeeeFeedabackActionTypes.SUBMIT_WEEE_USER_SELECTION:
      return {
        ...state,
        isLoading: true
      };
    case WeeeFeedabackActionTypes.SUBMIT_WEEE_USER_SELECTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status
      };
    case WeeeFeedabackActionTypes.SUBMIT_WEEE_USER_SELECTION_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: action.payload.type,
      };
    default:
      return state;
  }
}
